<template>
    <span class="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-nav-new-chat-bg">
        <i class="bi bi-plus text-lg/none text-nav-new-chat-icon" aria-hidden="true" />
    </span>
</template>
